import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import TextPage from '../views/Text-page.vue'
import services from '../views/services-page.vue'
import vacancy from '../views/vacancy-page.vue'
import contacts from '../views/contacts-page.vue'
import service from '../views/service.vue'
import vacancies from "../views/vacancy-page";
import objects from "../views/objects-page";
import page404 from "../views/404-page";

Vue.use(VueRouter)

const axios = require('axios')
let pages = {};
let comp;
const routes = [
	{path: '/api/services/', redirect: '/'},
	{path: '/api/', redirect: '/'},
]
axios.get(`https://gorsi.ru/api/?ajax&act=pages`,
	{responseType: 'json'}
).then(({data}) => {
	pages = JSON.parse(data.addons);
	
	for (let page in pages) {
		switch (pages[page].template.name) {
			case 'home':
				comp = Home
				break;
			case 'textpage':
				comp = TextPage
				break;
			case 'services':
				comp = services
				break;
			case 'service':
				comp = service
				break;
			case 'vacancy':
				comp = vacancy
				break;
			case 'contacts':
				comp = contacts
				break;
			case 'vacancies':
				comp = vacancies
				break;
			case 'objects':
				comp = objects
				break;
			// default:
			// 	comp = Home;
			// 	break;
		}
		let rout = {
			path: pages[page].path.replace('/api', ''),
			name: pages[page].name,
			component: comp
		};
		routes.push(rout)
	}
	let rout = {
		path: '*',
		name: '404',
		component: page404
	};
	routes.push(rout)
	router.addRoutes(routes)
})


const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition || to.path == this.currentRoute.path && from.path ==this.currentRoute.path) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	}
})


export default router
